'use client'

import { Button, ColorCode } from '@vinted/web-ui'
import { Flag24 } from '@vinted/monochrome-icons'
import { v4 as uuid } from 'uuid'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { setSessionStorageItem } from '@marketplace-web/browser/browser-storage-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { urlWithParams } from '@marketplace-web/shared/utils'
import { REPORT_SESSION_ID_KEY, AlertType } from '@marketplace-web/admin-alert/admin-alert-data'
import {
  clickEvent,
  ItemPageReportButtonPluginModel,
} from '@marketplace-web/report-button/report-button-data'

import { NEW_ADMIN_ALERT_URL } from '../constants/routes'

type Props = {
  data: ItemPageReportButtonPluginModel | undefined
}

const ItemPageReportButtonPlugin = ({ data }: Props) => {
  const translate = useTranslate()
  const { relativeUrl } = useBrowserNavigation()
  const currentUser = useSession().user
  const { track } = useTracking()

  if (!data) return null
  if (data.isItemSold) return null
  if (currentUser && data.ownerId === currentUser.id) return null

  const url = urlWithParams(NEW_ADMIN_ALERT_URL, {
    ref_id: data.itemId,
    ref_type: AlertType.Item,
    ref_url: relativeUrl,
  })

  const handleButtonClick = () => {
    setSessionStorageItem(REPORT_SESSION_ID_KEY, uuid())

    track(
      clickEvent({
        screen: 'item',
        target: 'report_item',
        targetDetails: String(data.itemId),
      }),
    )
  }

  return (
    <Button
      onClick={handleButtonClick}
      iconName={Flag24}
      iconColor={ColorCode.GreyscaleLevel2}
      title={translate('item.actions.report')}
      styling={Button.Styling.Flat}
      url={url}
      inline
      rel="nofollow"
      testId="item-report-button"
    />
  )
}

export default ItemPageReportButtonPlugin
